import { render, staticRenderFns } from "./third-party-manger.vue?vue&type=template&id=51e2046b"
import script from "./third-party-manger.vue?vue&type=script&lang=js"
export * from "./third-party-manger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports